// @ts-nocheck

import React, { createContext, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { useViewportContext } from '../../../../contexts/ViewportContext';
import useModalContext from '../../../../hooks/useModalContext';
import { computeAppBarHeight } from '../../../../utils/layout';

const Wrapper = styled.div`
  position: relative;
  padding: 1em;
  transform: translateZ(0);
  min-height: 100%;
  overflow: hidden;

  ${({ $availableHeight, $availableWidth }) => css`
    width: ${$availableWidth ? `${$availableWidth}px` : '100%'};
    height: ${$availableHeight}px;
  `}
`;

type GRViewContextState = {
  height: number;
};

export const GRViewContext = createContext<GRViewContextState>({ height: 0 });

type GRViewWrapperProps = {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
};

const GRViewWrapper = ({ className = '', children, onClick }: GRViewWrapperProps) => {
  const { height, ratio, domNodeRef } = useViewportContext();
  const { height: modalHeight, width: modalWidth } = useModalContext();

  const { navbarHeight, tabbarHeight } = useMemo(
    () => (ratio && domNodeRef && domNodeRef.current ? computeAppBarHeight(ratio, domNodeRef.current) : {}),
    [ratio, domNodeRef],
  );

  const availableHeight = useMemo(
    () => (modalHeight ? modalHeight : height - navbarHeight - tabbarHeight),
    [height, modalHeight, navbarHeight, tabbarHeight],
  );

  const providedState = useMemo(() => ({ height: availableHeight }), [availableHeight]);

  return (
    <Wrapper
      id="gr-view-wrapper"
      className={className}
      $availableHeight={availableHeight}
      $availableWidth={modalWidth}
      onClick={onClick}
    >
      <GRViewContext.Provider value={providedState}>{children}</GRViewContext.Provider>
    </Wrapper>
  );
};

export default GRViewWrapper;
